import * as config from '../../core/config'
import * as logoutApi from '../../api/logout'
import * as shopApi from '../../api/os/myshop/shop'

const self = {
  state: {
    // 用户信息
    info: {},
    // 岗位列表
    officerList: [],
    // 登录门店
    loginShop: {}
  },

  mutations: {
    SET_SELF_INFO: (state, data) => {
      state.info = data
      if (data && data.link_id) {
        //设置第三方ID
        config.setLinkId(data.link_id);
      } else {
        config.setLinkId(null);
      }
    },
    SET_SELF_OFFICER_LIST: (state, data) => {
      state.officerList = data
    },
    SET_SESSION_LOGIN_SHOP: (state, data) => {
      state.loginShop = data
    }
  },
  actions: {
    setSelfInfo ({commit}, data) {
      commit('SET_SELF_INFO', data)
      //获取登录门店
      shopApi.getLoginShop(null).then(rr => {
        commit('SET_SESSION_LOGIN_SHOP', rr.data)
      }).catch(() => {
        commit('SET_SESSION_LOGIN_SHOP', {})
      })
    },
    setSelfOfficerList ({commit}, data) {
      commit('SET_SELF_OFFICER_LIST', data)
    },
    logout ({commit}) {
      return new Promise((resolve, reject) => {
        logoutApi.logout(null).then(rr => {
          config.setAccessToken(null)
          config.setLinkId(null)
          commit('SET_SELF_INFO', null)
          commit('SET_SELF_OFFICER_LIST', null)
          resolve()
        }).catch(rr => {
          // 特殊处理: 登出统一成功
          console.warn(rr)
          config.setAccessToken(null)
          config.setLinkId(null)
          commit('SET_SELF_INFO', null)
          commit('SET_SELF_OFFICER_LIST', null)
          resolve()
        })
      })
    },
    sso ({commit}) {
      return new Promise((resolve, reject) => {
        config.setAccessToken(null)
        commit('SET_SELF_INFO', null)
        commit('SET_SELF_OFFICER_LIST', null)
        resolve()
      })
    }
  }
}

export default self
